import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import { Typography } from '@pw-tech/omni-ui';
import { InfoIcon } from 'lucide-react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import FooterPortal from '@/modules/common/Portals/FooterPortal/FooterPortal';
import { getNextStep } from '@/modules/common/utils';
import { CounsellingPreference as CounsellingPreferenceEnum } from '@/modules/common/enums';
const counsellingOptions = [{
  label: 'Online',
  value: CounsellingPreferenceEnum.ONLINE
}, {
  label: 'Offline',
  value: CounsellingPreferenceEnum.OFFLINE
}];
const CounsellingPreference = () => {
  const {
    registrationDetails,
    submitRegisterForm,
    isFormSubmitting
  } = useContext(RegistrationContext);
  const router = useRouter();
  const [selectedOption, setSelectedOption] = useState<string>(registrationDetails?.counsellingPreference ?? '');
  const isAlreadySubmitted = !!registrationDetails?.counsellingPreference;
  const handleSubmit = () => {
    submitRegisterForm({
      counsellingPreference: selectedOption,
      step: getNextStep(router.query.step, registrationDetails?.step)
    }, true);
  };
  return <section data-sentry-component="CounsellingPreference" data-sentry-source-file="CounsellingPreference.tsx">
      <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="CounsellingPreference.tsx">
        Select Your Counselling Preference
      </Typography>

      <div className="flex gap-3 mt-6">
        {counsellingOptions.map(option => <label key={option.value} className={`flex items-center gap-2 px-6 py-4 border rounded-lg transition-all ${isAlreadySubmitted ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${selectedOption === option.value ? 'border-[#196CDC] bg-[#F0F6FF]' : 'border-[#E0E0E0] bg-white'}`}>
            <input type="radio" name="counsellingPreference" value={option.value} checked={selectedOption === option.value} onChange={() => !isAlreadySubmitted && setSelectedOption(option.value)} disabled={isAlreadySubmitted} className="w-4 h-4 accent-[#196CDC]" />
            <Typography variant="regular" weight="semi-bold">
              {option.label}
            </Typography>
          </label>)}
      </div>

      {selectedOption && <div className="flex items-center gap-2 mt-6">
          <div className="flex items-center justify-center flex-shrink-0">
            <InfoIcon size={20} color="#757575" />
          </div>
          <Typography variant="regular" className="!text-sm !text-[#757575]">
            {selectedOption === CounsellingPreferenceEnum.OFFLINE ? 'You will be informed with Counselling Dates and Venue soon.' : 'You will be informed with Counselling Dates soon.'}
          </Typography>
        </div>}

      {!isAlreadySubmitted && <div className="flex items-start gap-1.5 mt-4">
          <Typography variant="regular" className="!text-sm !text-red-500 font-bold">
            *
          </Typography>
          <Typography variant="regular" weight="semi-bold" className="!text-sm !text-gray-500">
            We recommend reviewing your choice carefully — once submitted, your counselling
            preference will be locked and cannot be revised.
          </Typography>
        </div>}

      <div className="h-8" />
      <div className="py-2">
        <FooterPortal label="Continue" type="button" btnWrapperClass="relative sm:left-[31%]" onClick={handleSubmit} disabled={!selectedOption || isFormSubmitting} isFormSubmitting={isFormSubmitting} data-sentry-element="FooterPortal" data-sentry-source-file="CounsellingPreference.tsx" />
      </div>
    </section>;
};
export default CounsellingPreference;